export const Types = {
    GET_NOTIFICATION_LIST: "GET_NOTIFICATION_LIST",
    SET_NOTIFICATION_LIST: "SET_NOTIFICATION_LIST",
    READ_USER_NOTIFICATION: "READ_USER_NOTIFICATION",
    GET_NOTIFICATION_SUBSCRIPTION_OF_USER: "GET_NOTIFICATION_SUBSCRIPTION_OF_USER",
    SET_NOTIFICATION_SUBSCRIPTION_OF_USER: "SET_NOTIFICATION_SUBSCRIPTION_OF_USER",
    SET_SUBSCRIBE_NOTIFICATION: "SET_SUBSCRIBE_NOTIFICATION",
    NOTIFICATION_DELETE: "NOTIFICATION_DELETE",

    GET_NOTIFICATION_LANGUAGES: "GET_NOTIFICATION_LANGUAGES",
    SET_NOTIFICATION_LANGUAGES: "SET_NOTIFICATION_LANGUAGES",
    SET_NOTIFICATION_LANGUAGE: "SET_NOTIFICATION_LANGUAGE",
    SET_USER_NOTIFICATION_LANGUAGE: "SET_USER_NOTIFICATION_LANGUAGE",
};

export const getNotificationList = (userName) => ({
    type: Types.GET_NOTIFICATION_LIST,
    payload: userName,
});

export const readUserNotification = (userName) => ({
    type: Types.READ_USER_NOTIFICATION,
    payload: userName,
});

export const getNotificationHistory = (notificationId) => ({
    type: Types.GET_NOTIFICATION_LIST,
    payload: notificationId,
});

export const setNotificationList = (payload) => ({
    type: Types.SET_NOTIFICATION_LIST,
    payload: payload,
});

export const setSubscribeNotification = (payload, fromOverview) => ({
    type: Types.SET_SUBSCRIBE_NOTIFICATION,
    payload: payload, fromOverview
});

export const getNotificationSubscriptionOfUser = (userName) => ({
    type: Types.GET_NOTIFICATION_SUBSCRIPTION_OF_USER,
    payload: userName,
});

export const setNotificationSubscriptionOfUser = (userName) => ({
    type: Types.SET_NOTIFICATION_SUBSCRIPTION_OF_USER,
    payload: userName,
});

export const deleteSubscription = (payload, fromOverview) => ({
    type: Types.NOTIFICATION_DELETE,
    payload: payload, fromOverview
});

export const getNotificationLanguages = () => ({
    type: Types.GET_NOTIFICATION_LANGUAGES,
});

export const setNotificationLanguages = (payload) => ({
    type: Types.SET_NOTIFICATION_LANGUAGES,
    payload: payload,
});

export const setNotificationLanguage = (payload) => ({
    type: Types.SET_NOTIFICATION_LANGUAGE,
    payload: payload,
});

export const setUserNotificationLanguage = (payload) => ({
    type: Types.SET_USER_NOTIFICATION_LANGUAGE,
    payload: payload,
});